import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.tc('column 1', 1),
            colId: 'column1',
            field: 'column1',
            minWidth: 150,
            suppressSizeToFit: true,
            filter: true,
            sortable: false
        },
        {
            type: 'text',
            headerName: i18n.t('column 2'),
            colId: 'column2',
            field: 'column2',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: true,
            sortable: false
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]
}
